export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "SEARCH_PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quick search"])},
        "QUICK_SEARCH_LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Results"])},
        "RECENT_LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recently viewed"])},
        "NO_RESULTS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No results found"])},
        "QUICK_ACTION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Can’t find what you’re looking for?"])},
        "ADVANCED_SEARCH": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Advanced search"])}
      }
    }
  })
}
